import React from 'react';
import styled from 'styled-components';
import { FiPercent, FiTag, FiChevronRight } from 'react-icons/fi';

const Container = styled.div`
  padding: 32px;
`;

const Header = styled.div`
  margin-bottom: 32px;
`;

const Title = styled.h1`
  font-size: 32px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
`;

const Subtitle = styled.p`
  font-size: 16px;
  color: #6b7280;
`;

const CardsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const FeatureCard = styled.div`
  background: white;
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 24px;
  display: flex;
  align-items: center;
  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
    transform: translateY(-2px);
  }
`;

const IconContainer = styled.div`
  width: 64px;
  height: 64px;
  background: #1f2937;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 24px;
  flex-shrink: 0;
`;

const IconWrapper = styled.div`
  color: #5efba9;
  font-size: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const CardContent = styled.div`
  flex: 1;
`;

const CardTitle = styled.h3`
  font-size: 20px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 8px;
`;

const CardDescription = styled.p`
  font-size: 14px;
  color: #6b7280;
  line-height: 1.5;
`;

const CardArrow = styled.div`
  color: #9ca3af;
  font-size: 24px;
  margin-left: 24px;
  display: flex;
  align-items: center;
`;

const CodeIcon = styled.div`
  font-size: 20px;
  font-weight: 700;
  color: #5efba9;
  letter-spacing: 2px;
`;

function AdminPromotions() {
  return (
    <Container>
      <Header>
        <Title>Promotions</Title>
        <Subtitle>Use this feature to increase your store performance.</Subtitle>
      </Header>

      <CardsContainer>
        <FeatureCard>
          <IconContainer>
            <IconWrapper>
              <FiPercent />
            </IconWrapper>
          </IconContainer>
          <CardContent>
            <CardTitle>Discount</CardTitle>
            <CardDescription>
              Make your product to be the first line on the searching result.
            </CardDescription>
          </CardContent>
          <CardArrow>
            <FiChevronRight />
          </CardArrow>
        </FeatureCard>

        <FeatureCard>
          <IconContainer>
            <IconWrapper>
              <CodeIcon>CODE</CodeIcon>
            </IconWrapper>
          </IconContainer>
          <CardContent>
            <CardTitle>Code Voucher</CardTitle>
            <CardDescription>
              Give a cashback voucher for your customer.
            </CardDescription>
          </CardContent>
          <CardArrow>
            <FiChevronRight />
          </CardArrow>
        </FeatureCard>
      </CardsContainer>
    </Container>
  );
}

export default AdminPromotions;
